// FAQ route (public storefront) — Polish. Keys mirror en/faq.ts; strings are the exact
// current copy, verbatim. Rich-answer fragments use {b0}/{b1}… placeholders for <b>
// emphasis spans and {link} for inline links; the component supplies the JSX.
export const faq = {
  hero: {
    title: 'Najczęstsze pytania',
    // Nagłówek strony ma tytuł i JEDNĄ drogę do skrzynki (artboard 02); zdanie
    // wprowadzające i karta kontaktowa na dole wyleciały przez zasadę 8.
    leadLink: 'Napisz do nas',
  },
  cat: {
    general: 'Ogólne',
    // Reguła 34: słowem waluty w języku produktu jest token (MAPA 37-R3).
    tokens: 'Tokeny i płatności',
    accounts: 'Konta i publikacja',
    plans: 'Plany',
  },
  items: {
    whatIsEdimi: {
      q: 'Czym właściwie jest EDIMI?',
      a: 'EDIMI to {b0}generator fanowskich editów{b1} dla artystów muzycznych i labeli. Wgrywasz utwór i wskazujesz fragment do 30 sekund, a Generator robi z niego {b2}masę unikatowych editów{b3} - pionowych, ciętych do beatu, bez montażysty i bez timeline’u. Potem EDIMI publikuje je na Twojej sieci własnych kont TikTok, Instagram i YouTube przez oficjalne API, w dni i godziny, które zatwierdzasz.',
    },
    // Film o czterech mechanizmach (27.09), M2+M3: pytanie, które budzi hasło hero. Odpowiedź
    // zaczyna się od odmowy i nie ma żadnej liczby (inwariant 2); Faq.test tego pilnuje.
    noMiracle: {
      q: 'Czy EDIMI zrobi mi viral?',
      a: 'Nie - i nikt uczciwy Ci tego nie obieca. Nie ma jednego najlepszego editu, liczy się {b0}seria{b1}: masa unikatowych editów z jednego utworu, wychodzących regularnie na Twoich kontach w dni i godziny, które zatwierdzasz. Nie czekasz na cud: fanbase budujesz sam.',
    },
    // Plan łączy dwa pytania w jedno: obie odpowiedzi mówiły o tym samym — skąd
    // bierze się obraz i że montażu nie ma. Odpowiedź to złożenie obu (MAPA 37).
    whereShots: {
      q: 'Skąd klipy i czy muszę umieć montować?',
      a: 'Masz dwie drogi: korzystasz z {b0}gotowych paczek klipów{b1} albo wrzucasz {b2}własne materiały{b3} - np. swoje teledyski. Montażu nie musisz umieć: EDIMI sam tnie je i skleja do beatu Twojego utworu, dokłada {b4}synced lyrics{b5}, których styl edytujesz pod swoją markę, a na start, jeśli chcesz, {b6}hook{b7} z gotowej paczki albo z Twojej własnej.',
    },
    freeStart: {
      q: 'Co dostaję za darmo na start?',
      // {n} {edits} podaje komponent z FREE_START_EDITS (lib/startBonus.ts), tak jak mikrotekst
      // strony głównej: wpisana tu piątka rozjechałaby się z backendem przy zmianie stawki.
      // Film o czterech mechanizmach (27.09), M1: efekt na własnej muzyce, zanim cokolwiek zapłacisz.
      // Zdania o koncie bez planu tu NIE MA: backend daje jeden slot, ale na prodzie podłączanie kont
      // widzi tylko lista bety (`campaigns_allowed`, Accounts.tsx `featureOff`), przegląd 27.09.
      a: 'Po założeniu konta dostajesz {b0}{n} {edits} gratis{b1} - bez podawania karty. Efekt sprawdzasz na własnej muzyce, zanim wybierzesz plan.',
    },
    whatIsToken: {
      q: 'Czym jest token?',
      // STAWKI SKŁADA EKRAN Z ODPOWIEDZI API (`gem_costs`), nigdy ten plik. Zdanie
      // wpisane tu na sztywno („1 token, 1 token, 10 tokenów”) obiecywało klientowi
      // przed zakupem coś innego niż Cennik i niż serwer, który nalicza 3 / 2 / 5.
      // Kto zmienia stawkę w `app/billing/costs.py`, nie ma tu nic do poprawienia.
      a: 'Token to jednostka, którą płacisz za pracę aplikacji. {b0}Wygenerowanie editu kosztuje {render}, opublikowanie posta {publish}, a pocięcie własnego pliku na klipy {cut}.{b1} Nieudana operacja nie kosztuje - tokeny wracają automatycznie.',
      // Bez odpowiedzi API zdanie stoi BEZ liczb i odsyła tam, gdzie stawki są
      // zawsze aktualne. Front nie obiecuje ceny z własnej pamięci.
      aNoPrices: 'Token to jednostka, którą płacisz za pracę aplikacji. Aktualne stawki za edit, publikację i pocięcie pliku stoją w {link}. Nieudana operacja nie kosztuje - tokeny wracają automatycznie.',
      link: 'Cenniku',
    },
    runOut: {
      q: 'Co, jeśli skończą mi się tokeny?',
      a: 'Możesz {b0}dokupić jednorazową paczkę{b1} tokenów - są ważne 24 miesiące od zakupu i zostają na koncie także po odnowieniu planu. Najmniejsza paczka jest dostępna w każdym planie, największe pakiety w planie Max.',
    },
    rollover: {
      q: 'Czy niewykorzystane tokeny przechodzą na kolejny miesiąc?',
      a: 'Tokeny z miesięcznej puli planu resetują się co okres rozliczeniowy. Tokeny z {b0}doładowań{b1} są ważne 24 miesiące od zakupu i są zużywane dopiero po wyczerpaniu puli miesięcznej.',
    },
    payMethods: {
      q: 'Jakie metody płatności obsługujecie?',
      a: 'Płatności obsługujemy bezpiecznie przez {b0}Stripe{b1}, który akceptuje {b2}międzynarodowe karty płatnicze{b3}. Faktury VAT generowane są automatycznie.',
    },
    howMany: {
      q: 'Ile editów mogę wygenerować naraz?',
      a: 'Do {b0}100 jednym kliknięciem{b1}, w ramach Twojej puli tokenów - każdy z innym układem klipów. W Planerze wybierasz konta i terminy, a przyciskiem „Zaplanuj” zatwierdzasz cały plan.',
    },
    // Hasło hero „sieć kont” dostaje w FAQ znaczenie z produktu: własne konta, oficjalne
    // logowanie, zgoda (inwariant 1). Nie zmiękczać bez słowa właściciela; Faq.test pilnuje.
    network: {
      q: 'Czym jest moja sieć kont?',
      // Bezpieczniki są z kodu: `render_reused` i DEFAULT_CAP_PER_DAY (app/campaigns/planner.py,
      // capacity.py); zasady platform: Regulamin §10 ust. 2. Liczby limitu tu nie ma (Faq.test).
      a: 'To Twoje własne konta TikTok, Instagram i YouTube - tyle, na ile masz sloty. Każde łączysz {b0}oficjalnym logowaniem platformy{b1} i każde zostaje Twoje. Każde dostaje własne edity: ten sam edit nie wyjdzie na dwóch kontach, a posty idą w dziennym limicie na konto. Nic nie wychodzi bez Twojej zgody, a zasady platform obowiązują Cię tak samo jak bez EDIMI. EDIMI nie zakłada, nie sprzedaje i nie wypożycza kont.',
    },
    howPublish: {
      q: 'Jak EDIMI publikuje na moich kontach?',
      // „każdy post zatwierdzasz osobno” przestało być prawdą z Regulaminem 2026-09-24.2
      // (§10 ust. 2): „Zaplanuj” zatwierdza każdy post planu. Faq.test tego pilnuje.
      a: 'Logujesz się na stronie platformy - TikToka, Instagrama albo Google dla YouTube - i autoryzujesz konto (OAuth), a EDIMI publikuje {b0}wyłącznie przez oficjalne API tych platform{b1}. Nigdy nie widzimy Twojego hasła. Nic nie wychodzi bez Twojej zgody: zatwierdzasz pojedynczy post albo cały plan przyciskiem „Zaplanuj”. Bez automatów na telefonie.',
    },
    howManyAccounts: {
      q: 'Ile kont mogę podłączyć?',
      a: 'Zależy od planu: Starter - 1 konto, Pro - 8 kont, Max - 40 kont. Podłączasz {b0}własne konta TikTok, Instagram i YouTube{b1}. Slot pozostaje przypisany do tego samego konta do końca okresu rozliczeniowego, a bez planu - do końca miesiąca UTC. Odłączenie nie zwalnia go wcześniej. To samo konto możesz połączyć ponownie bez dodatkowego slotu. Możesz też dokupić sloty.',
    },
    changePlan: {
      q: 'Czy mogę zmienić plan w trakcie?',
      // „nowa pula tokenów dostępna od razu" było nieprawdą o pieniądzach:
      // `reset_plan_balance` odnawia pulę WYŁĄCZNIE na `subscription_cycle`,
      // nie przy zmianie planu — i tak też mówi Regulamin. Zdanie o pakietach
      // jednorazowych dopisane, bo to jest pierwsze pytanie po pierwszym zdaniu.
      a: 'Tak. Plan podniesiesz lub obniżysz w dowolnym momencie - rozliczenie jest proporcjonalne. Nowa pula tokenów odnawia się dopiero w dniu rozliczenia kolejnego okresu; tokeny z pakietów jednorazowych zostają na koncie bez zmian.',
    },
    cancel: {
      q: 'Czy mogę anulować subskrypcję?',
      a: 'Tak, sam i online: {b0}Rozliczenia → „Zarządzaj płatnością” → Anuluj subskrypcję{b1} w portalu klienta. Nie musisz do nas pisać. Zachowujesz dostęp i tokeny z planu do końca opłaconego okresu, a dokupione tokeny zostają na koncie do końca 24-miesięcznego terminu ważności.',
    },
    withdrawal: {
      q: 'Mam 14 dni na odstąpienie od umowy?',
      a: 'Tak - to prawo odrębne od anulowania subskrypcji. W ciągu {b0}14 dni od zakupu{b1} możesz odstąpić bez podania przyczyny, pisząc na kontakt@edimi.ai. Zwracamy opłatę {b2}pomniejszoną o wartość tokenów, które zdążyłeś zużyć{b3} - za niezużyte oddajemy pełną kwotę. Prawo do odstąpienia nie wygasa dlatego, że minęło kilka dni; wygasa wyłącznie co do treści już dostarczonej, czyli co do zużytych tokenów. Szczegóły w §11 Regulaminu.',
    },
    deleteAccount: {
      q: 'Co się dzieje z moimi plikami, gdy usunę konto?',
      // Brzmienie planu (artboard 02): trzy zdania zamiast pięciu, ten sam fakt.
      a: 'Pliki i edity usuwamy w {b0}30 dni{b1} od usunięcia konta. Dłużej trzymamy tylko dokumentację księgową, jak wymaga prawo. Pobierz edity wcześniej.',
    },
    reportContent: {
      q: 'Ktoś wykorzystał mój utwór albo mój wizerunek. Co mogę zrobić?',
      a: 'Zgłoś to - {link}. Konto w EDIMI nie jest do tego potrzebne. Zgłoszenie czyta człowiek, nie automat; potwierdzenie odbioru wysyłamy od razu, a o decyzji i jej powodach informujemy Cię osobno. Działamy w trybie art. 16 aktu o usługach cyfrowych.',
      link: 'formularz zgłoszenia treści',
    },
    descriptor: {
      q: 'Co zobaczę na wyciągu z karty?',
      a: 'Obciążenie pojawi się jako {b0}EDIMI{b1}. Jeśli widzisz płatność, której nie rozpoznajesz - napisz do nas, zanim zgłosisz ją w banku; wyjaśnimy szybciej. Ceny w cenniku są brutto i zawierają VAT.',
    },
  },
}
